import { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_VISIBLE_MS = 3_000;

/** A flag that `trigger` raises and a timer lowers, for brief on-screen hints. */
export function useTransientFlag(visibleMs = DEFAULT_VISIBLE_MS): {
  active: boolean;
  trigger: () => void;
} {
  const [active, setActive] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const trigger = useCallback(() => {
    clearTimeout(timerRef.current);
    setActive(true);
    timerRef.current = setTimeout(() => setActive(false), visibleMs);
  }, [visibleMs]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return { active, trigger };
}
